(() => {
const initialize = (scope=document) => {
scope.querySelectorAll('[data-language-select]').forEach(select=>{if(select.dataset.ready)return;select.dataset.ready='true';select.addEventListener('change',()=>select.form.requestSubmit());});
scope.querySelectorAll('[data-gallery]').forEach(gallery=>{if(gallery.dataset.ready)return;gallery.dataset.ready='true';gallery.querySelectorAll('[data-gallery-image]').forEach(link=>link.addEventListener('click',event=>{const image=gallery.querySelector('.gallery-image-wrap img');if(!image)return;event.preventDefault();image.removeAttribute('srcset');image.src=link.dataset.galleryImage;image.alt=link.dataset.galleryAlt;}));});
scope.querySelectorAll('[data-variant-select]').forEach(select=>{if(select.dataset.ready)return;select.dataset.ready='true';select.addEventListener('change',()=>{const option=select.selectedOptions[0],section=select.closest('.native-product'),button=select.form.querySelector('[data-add-button]');section.querySelector('[data-variant-price]').textContent=option.dataset.price;button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.unavailableLabel:button.dataset.availableLabel;const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);});});
scope.querySelectorAll('[data-native-hero]').forEach(hero=>{
if(hero.dataset.ready)return;hero.dataset.ready='true';
const track=hero.querySelector('.hero-track'),slides=[...track.children],n=slides.length,motion=matchMedia('(prefers-reduced-motion: reduce)');
if(n<2)return;
let index=0,visual=1,timer,animationTimer,moving=false,gesture=null,hover=false,inView=true,suppress=false,wheel=0,wheelTime=0,wheelLock=0;
const before=slides[n-1].cloneNode(true),after=slides[0].cloneNode(true);
[before,after].forEach(clone=>{clone.dataset.clone='true';clone.inert=true;clone.setAttribute('aria-hidden','true');clone.removeAttribute('data-shopify-editor-block');});
track.prepend(before);track.append(after);track.style.transform='translate3d(-100%,0,0)';
const panels=[...track.children];
const schedule=()=>{clearTimeout(timer);if(!motion.matches&&!document.hidden&&!hover&&inView&&!moving&&!gesture&&!hero.contains(document.activeElement))timer=setTimeout(()=>move(1),6000);};
const update=()=>{panels.forEach(panel=>{const active=!panel.dataset.clone&&Number(panel.dataset.slideIndex)===index;panel.inert=!active;panel.setAttribute('aria-hidden',String(!active));});hero.querySelectorAll('[data-hero-slide]').forEach(dot=>dot.setAttribute('aria-pressed',String(Number(dot.dataset.heroSlide)===index)));};
const finish=()=>{if(!moving)return;clearTimeout(animationTimer);moving=false;visual=index+1;track.classList.remove('is-moving');track.style.transform=`translate3d(${-100*visual}%,0,0)`;schedule();};
const to=(target,direction)=>{if(moving)return;clearTimeout(timer);index=(target+n)%n;visual=index+1;if(direction>0&&index===0)visual=n+1;if(direction<0&&index===n-1)visual=0;moving=true;track.classList.add('is-moving');track.style.transform=`translate3d(${-100*visual}%,0,0)`;update();animationTimer=setTimeout(finish,motion.matches?0:1000);};
const move=(step)=>to(index+step,step);
track.addEventListener('transitionend',event=>{if(event.propertyName==='transform')finish();});
hero.querySelectorAll('[data-hero-step]').forEach(button=>button.addEventListener('click',()=>move(Number(button.dataset.heroStep))));
hero.querySelectorAll('[data-hero-slide]').forEach(button=>button.addEventListener('click',()=>{const target=Number(button.dataset.heroSlide);if(target!==index)to(target,Math.sign(target-index));}));
hero.addEventListener('mouseenter',()=>{hover=true;clearTimeout(timer);});hero.addEventListener('mouseleave',()=>{hover=false;schedule();});hero.addEventListener('focusin',()=>clearTimeout(timer));hero.addEventListener('focusout',()=>setTimeout(schedule,0));
hero.addEventListener('pointerdown',event=>{if(moving||event.button!==0||event.target.closest('.hero-controls'))return;gesture={id:event.pointerId,x:event.clientX,y:event.clientY,dx:0,drag:false};clearTimeout(timer);});
hero.addEventListener('pointermove',event=>{if(!gesture||event.pointerId!==gesture.id)return;const dx=event.clientX-gesture.x,dy=event.clientY-gesture.y;if(!gesture.drag){if(Math.abs(dy)>Math.abs(dx)&&Math.abs(dy)>10){gesture=null;schedule();return;}if(Math.abs(dx)<10)return;gesture.drag=true;hero.setPointerCapture(event.pointerId);hero.classList.add('is-dragging');}gesture.dx=dx;track.style.transform=`translate3d(calc(${-100*(index+1)}% + ${dx}px),0,0)`;});
const end=event=>{if(!gesture||event.pointerId!==gesture.id)return;const g=gesture;gesture=null;hero.classList.remove('is-dragging');if(hero.hasPointerCapture(event.pointerId))hero.releasePointerCapture(event.pointerId);if(g.drag){suppress=true;setTimeout(()=>suppress=false,350);if(Math.abs(g.dx)>Math.min(80,hero.clientWidth*.15))move(g.dx<0?1:-1);else{moving=true;track.classList.add('is-moving');track.style.transform=`translate3d(${-100*(index+1)}%,0,0)`;animationTimer=setTimeout(finish,1000);}}else schedule();};
hero.addEventListener('pointerup',end);hero.addEventListener('pointercancel',event=>{if(gesture?.id===event.pointerId){gesture=null;hero.classList.remove('is-dragging');moving=true;track.classList.add('is-moving');track.style.transform=`translate3d(${-100*(index+1)}%,0,0)`;animationTimer=setTimeout(finish,1000);}});
hero.addEventListener('click',event=>{if(suppress){event.preventDefault();event.stopPropagation();}},true);hero.addEventListener('dragstart',event=>event.preventDefault());
hero.addEventListener('wheel',event=>{if(Math.abs(event.deltaX)<=Math.abs(event.deltaY))return;event.preventDefault();const now=Date.now();if(moving||now-wheelLock<1100)return;if(now-wheelTime>200)wheel=0;wheelTime=now;wheel+=event.deltaX;if(Math.abs(wheel)>45){move(wheel>0?1:-1);wheel=0;wheelLock=now;}},{passive:false});
hero.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
document.addEventListener('visibilitychange',schedule);motion.addEventListener('change',schedule);new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;schedule();},{threshold:.15}).observe(hero);update();schedule();
});
};
initialize();document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
(() => {
  if (window.valerisCardGalleryReady) return;
  window.valerisCardGalleryReady = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let active = null, timer = null, generation = 0;
  const show = (card, index) => {
    card.querySelectorAll('[data-card-slide]').forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    const frame = card.querySelector('[data-card-frame]');
    if (frame) frame.dataset.cardIndex = String(index);
  };
  const stop = () => {
    clearTimeout(timer);
    generation++;
    if (active) show(active, 0);
    active = null;
  };
  const start = card => {
    if (active === card || motion.matches || document.hidden) return;
    stop();
    const slides = [...card.querySelectorAll('[data-card-slide]')];
    if (slides.length < 2) return;
    active = card;
    const token = generation;
    let index = 0;
    const advance = async () => {
      if (token !== generation || active !== card || !card.isConnected || document.hidden || motion.matches) return stop();
      const next = (index + 1) % slides.length;
      const image = slides[next].querySelector('img');
      try {
        if (image) {
          image.loading = 'eager';
          if (image.decode) await image.decode();
        }
        if (token !== generation || active !== card) return;
        if (!image || image.naturalWidth > 0) { index = next; show(card, index); }
      } catch {}
      if (token === generation && active === card) timer = setTimeout(advance, 1800);
    };
    slides.slice(1).forEach(slide => { const image = slide.querySelector('img'); if (image) image.loading = 'eager'; });
    timer = setTimeout(advance, 700);
  };
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse' || !(event.target instanceof Element)) return;
    const card = event.target.closest('[data-card-gallery]');
    if (card && !card.contains(event.relatedTarget)) start(card);
  });
  document.addEventListener('pointerout', event => {
    if (active && event.target instanceof Element && active.contains(event.target) && !active.contains(event.relatedTarget)) stop();
  });
  document.addEventListener('visibilitychange', stop);
  document.addEventListener('shopify:section:unload', stop);
  window.addEventListener('blur', stop);
  window.addEventListener('hashchange', stop);
  motion.addEventListener('change', stop);
})();
(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-variant-input]').forEach(input => {
      if (input.dataset.ready) return;
      input.dataset.ready = 'true';
      input.addEventListener('change', () => {
        if (!input.checked) return;
        const section = input.closest('.native-product');
        const price = section.querySelector('[data-variant-price]');
        const button = input.form.querySelector('[data-add-button]');
        price.textContent = input.dataset.price;
        button.disabled = input.dataset.available !== 'true';
        button.textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.availableLabel;
        const url = new URL(location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url);
      });
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-card-variant]');
    if (!button) return;
    const card = button.closest('[data-card-gallery]');
    if (!card) return;
    card.querySelectorAll('[data-card-variant]').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
    card.querySelectorAll('[data-card-product-link]').forEach(link => link.href = button.dataset.variantUrl);
    const price = card.querySelector('[data-card-price-label]');
    if (price) price.textContent = button.dataset.cardPrice;
  });
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

// Reopen Shopify's own preference dialog without recording consent ourselves.
(() => {
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cookie-preferences]');
    if (!button || button.disabled) return;
    const status = button.parentElement.querySelector('[data-cookie-status]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) status.textContent = '';
    try {
      // Shopify loads its configured banner asynchronously through content_for_header.
      for (let attempt = 0; attempt < 20 && !window.privacyBanner?.showPreferences; attempt++) {
        await new Promise(resolve => setTimeout(resolve, 150));
      }
      if (!window.privacyBanner?.showPreferences) throw new Error('Banner unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      if (status) status.textContent = button.dataset.errorLabel;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
